
<template>
  <div class="container">
    <div id="page-div" class="container interline" ref="document">
      <div id="page2-div" class="container interline border page-container p-3">
        <div class="col-12 text-justify content-wrap">
          <div class="col-12 text-center">
            <span class="ft15Black"> <br />GPI AUTO COMERCIAL</span>
          </div>
          <div class="col-12 text-center">
            <span class="ft7Gray">
              <br />Av. De las Rosas 2991, Colonia. Chapalita, C.P. 44510,
              Guadalajara, Jalisco.<br />
            </span>
          </div>
          <div class="col-12 text-center">
            <span class="ft13Black border-bottom border-dark">
              <br />CONTRATO DE ARRENDAMIETO PURO <br /><br />
            </span>
          </div>
          <div class="col-12">
            <div class="text-justify">
              <span class="ft12">
                <span v-if="data.tipoABasic && !data.tipoAbout && !data.tipoAendorsement && !data.tipoAbound">
                  <br />Contrato de Arrendamiento Puro que celebra por una parte
                  <span class="ft12Black">GPI AUTO COMERCIAL SAPI DE C.V.</span>, quien comparece en carácter de
                  <span class="ft12Black">“Arrendador”</span>, representada en
                  este acto por el señor
                  <span class="ft12Black">Jesús Fernández Morán</span>, y por
                  la otra el señor (sra)
                  <span class="ft9Black" v-bind:class="{ marca: data.showMarca }">
                    {{ data.nombre_cliente }}
                  </span>
                  <span v-if="data.tipoAmoral">
                    representada en este acto por el señor
                    <span class="ft9Black" v-bind:class="{ marca: data.showMarca }">
                      {{ data.reprecentante_legal }}
                    </span>
                  </span>
                  , quien comparece en este acto en carácter de
                  <span class="ft12Black">“Arrendatario”</span>
                  y <span class="ft12Black">“Depositario”</span>; persona que
                  manifiesta tener capacidad legal para contratar y señalan es
                  su deseo celebrar el presente contrato, al tenor de las
                  siguientes Declaraciones y Cláusulas:
                </span>

                <span v-if="data.tipoAendorsement && !data.tipoAbout">
                  <br />Contrato de Arrendamiento Puro que celebra por una parte
                  <span class="ft12Black">GPI AUTO COMERCIAL SAPI DE C.V.</span>, quien comparece en carácter de
                  <span class="ft12Black">“Arrendador”</span>, representada en
                  este acto por el señor
                  <span class="ft12Black">Jesús Fernández Morán</span>, y por
                  la otra el señor (sra)
                  <span class="ft9Black" v-bind:class="{ marca: data.showMarca }">
                    {{ data.nombre_cliente }}
                  </span>
                  <span v-if="data.tipoAmoral">
                    representada en este acto por el señor (sra)
                    <span class="ft9Black" v-bind:class="{ marca: data.showMarca }">
                      {{ data.reprecentante_legal }}
                    </span>
                  </span>, quien comparece en este acto en carácter de
                  <span class="ft12Black">“Arrendatario”</span>,
                  el señor (sra)
                  <span class="ft9Black" v-bind:class="{ 'marca-aval': data.showMarca }">
                    {{ data.nombre_aval }}
                  </span>
                  , quien comparece en carácter de “Deudor Solidario y Aval”; y el señor (sra)
                  <span class="ft9Black" v-bind:class="{ marca: data.showMarca }">
                    {{ data.nombre_cliente }}
                  </span>
                  , quien comparece en carácter de
                  <span class="ft12Black">“Depositario”</span>; personas que
                  manifestaron tener capacidad legal para contratar y señalan es
                  su deseo celebrar el presente contrato, al tenor de las
                  siguientes Declaraciones y Cláusulas:
                </span>

                <span v-if="data.tipoAbound && !data.tipoAbout">
                  <br />Contrato de Arrendamiento Puro que celebra por una parte
                  <span class="ft12Black">GPI AUTO COMERCIAL SAPI DE C.V.</span>, quien comparece en carácter de
                  <span class="ft12Black">“Arrendador”</span>, representada en
                  este acto por el señor
                  <span class="ft12Black">Jesús Fernández Morán</span>, y por
                  la otra el señor (sra)
                  <span class="ft9Black" v-bind:class="{ marca: data.showMarca }">
                    {{ data.nombre_cliente }}
                  </span>
                  <span v-if="data.tipoAmoral">
                    representada en este acto por el señor (sra)
                    <span class="ft9Black" v-bind:class="{ marca: data.showMarca }">
                      {{ data.reprecentante_legal }}
                    </span>
                  </span>
                  , quien comparece en este acto en carácter de
                  <span class="ft12Black ">“Arrendatario”</span>, el señor (sra)
                  <span class="ft12" v-bind:class="{ 'marca-obligado': data.showMarca }">
                    {{ data.nombre_obligado }} </span>, quien comparece en carácter de
                  <span class="ft12Black ">“Deudor Solidario y Aval”</span>; y el señor
                  (sra)
                  <span class="ft12" v-bind:class="{ marca: data.showMarca }">
                    {{ data.nombre_cliente }} </span>, quien comparece en carácter de
                  <span class="ft12Black ">“Depositario”</span>; personas que
                  manifestaron tener capacidad legal para contratar y señalan es
                  su deseo celebrar el presente contrato, al tenor de las
                  siguientes Declaraciones y Cláusulas:
                </span>

                <span v-if="data.tipoAbout">
                  <br />Contrato de Arrendamiento Puro que celebra por una parte
                  <span class="ft12Black">GPI AUTO COMERCIAL SAPI DE C.V.</span>, quien comparece en carácter de
                  <span class="ft12Black">“Arrendador”</span>, representada en
                  este acto por el señor
                  <span class="ft12Black">Jesús Fernández Morán</span>, y por
                  la otra el señor (sra)
                  <span class="ft9Black" v-bind:class="{ marca: data.showMarca }">
                    {{ data.nombre_cliente }}
                  </span>
                  <span v-if="data.tipoAmoral">
                    representada en este acto por el señor (sra)
                    <span class="ft9Black" v-bind:class="{ marca: data.showMarca }">
                      {{ data.reprecentante_legal }}
                    </span>
                  </span>
                  , quien comparece en este acto en carácter de
                  <span class="ft12Black ">“Arrendatario”</span>, el señor (sra)
                  <span class="ft12" v-bind:class="{ 'marca-obligado': data.showMarca }">
                    {{ data.nombre_obligado }} </span>, quien comparece en carácter de
                  <span class="ft12Black ">“Deudor Solidario y Aval”</span> y el señor
                  <span class="ft12" v-bind:class="{ 'marca-aval': data.showMarca }">
                    {{ data.nombre_aval }}
                  </span>, quien comparece en carácter de
                  <span class="ft12Black ">“Deudor Solidario y Aval”;</span> y el señor
                  (sra)
                  <span class="ft12" v-bind:class="{ marca: data.showMarca }">
                    {{ data.nombre_cliente }} </span>, quien comparece en carácter de
                  <span class="ft12Black ">“Depositario”</span>; personas que
                  manifestaron tener capacidad legal para contratar y señalan es
                  su deseo celebrar el presente contrato, al tenor de las
                  siguientes Declaraciones y Cláusulas:
                </span>

                <br />
              </span>
              <span class="ft13Black ">
                <br />DECLARACIONES: <br /><br />
              </span>
              <span class="ft12">
                I.- Declara el <span class="ft12Black ">“Arrendador”</span>, a
                través de su Representante:<br />
              </span>
            </div>
            <span class="ft12 text-justify">
              a. Es una sociedad mercantil debidamente constituida y válidamente existente conforme a las leyes de los
              Estados Unidos Mexicanos, según consta en la Escritura Pública número 9,195, de fecha 23 de marzo de 2015,
              pasada ante la fe del Lic. Rodolfo Ramos Menchaca, Notario Público número 117 de Guadalajara, Jalisco; la
              cual quedó registrada bajo folio mercantil 90932*1 en el Registro Público de la Propiedad y de Comercio de
              Guadalajara, Jalisco, obligándose bajo los términos que se establecen en el Contrato.
              <br />
            </span>
            <span class="ft12 text-justify">
              b. Su Representante cuenta con los poderes y facultades suficientes para celebrar el presente Contrato de
              Préstamo Mercantil, los que a la fecha no le han sido revocados o limitados, como lo acredita con la
              Escritura Pública número 37,563 suscrita ante la fe del licenciado Guillermo Coronado Figueroa, notario
              público 50 de Guadalajara, Jalisco, de fecha 4 de Noviembre del 2021.
              <br />
            </span>
            <span class="ft12 text-justify">
              c. Que señalada como domicilio convencional para efectos del presente contrato el localizado en
              <span class="ft11Black ">
                Avenida de las Rosas 2991, Chapalita, C.P. 44510, Guadalajara,Jalisco.
              </span>
              Domicilio del cual la existencia ha sido verificada por las
              partes; así mismo señala para los efectos del presente Contrato el
              correo electrónico
              <span class="ft11Black ">atencionclientes@gpiautocomercial.com.mx </span><br />
            </span>
            <span class="ft12 text-justify">
              d. Que es su deseo celebrar el presente Contrato, en los términos
              y condiciones que en él se establecen.<br /><br />
            </span>
            <span v-if="!data.tipoAmoral">
              <span class="ft12"></span>
              <span class="ft12">
                II.- Declara el
                <span class="ft12Black ">“Arrendatario”</span>:<br />
              </span>
              <span class="ft12 text-justify">
                a. Es mexicano, mayor de edad, facultado para obligarse en los
                términos del presente convenio.
                <br />
              </span>
              <span class="ft12 text-justify">
                b. Señala como su domicilio el ubicado en
                CALLE
                <span class="ft12Black" v-bind:class="{ marca: data.showMarca }">
                  {{ data.calle_cliente }}
                </span>
                No.
                <span class="ft12Black" v-bind:class="{ marca: data.showMarca }">
                  {{ data.numero_calle_cliente }}</span>
                COLONIA
                <span class="ft12Black" v-bind:class="{ marca: data.showMarca }">
                  {{ data.colonia_cliente }},
                </span>
                CODIGO POSTAL
                <span class="ft12Black" v-bind:class="{ marca: data.showMarca }">
                  {{ data.codigo_postal_cliente }},
                </span>
                DE LA POBLACION DE
                <span class="ft12Black" v-bind:class="{ marca: data.showMarca }">
                  {{ data.municipio_cliente }},
                </span>
                MUNICIPIO DE
                <span class="ft12Black" v-bind:class="{ marca: data.showMarca }">
                  {{ data.municipio_cliente }},
                </span>
                <span class="ft12Black" v-bind:class="{ marca: data.showMarca }">
                  {{ data.estado_cliente }}. </span>
                <br />
              </span>
              <span class="ft12 text-justify">c. Cuenta con el Registro Federal de Contribuyentes
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.RFC }}
                </span>
                y correo
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.correo }}.
                </span>
                <br />
              </span>
              <span class="ft12 text-justify">
                d. Tener solvencia patrimonial, económica y moral para cubrir con
                las obligaciones derivadas del presente Contrato y las que por ley
                se deducen.
                <br /><br />
              </span>
            </span>

            <span v-if="data.tipoAmoral">
              <span class="ft12"></span>
              <span class="ft12">
                II.- Declara el
                <span class="ft12Black ">“Arrendatario”</span>:<br />
              </span>
              <span class="ft12 text-justify">
                a. Es una sociedad mercantil debidamente constituida y válidamente existente conforme a las leyes de los
                Estados Unidos Mexicanos, según consta en la Escritura Pública número
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.escritura_publica }}
                </span>,
                de fecha
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.escritura_fecha }},
                </span> pasada ante la fe del Lic.
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.escritura_licenciado }}
                </span>,
                Notario Público número
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.numero_notaria }}
                </span> de
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.municipio_notaria }},
                </span>
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.estado_notaria }},
                </span> la cual quedó registrada bajo folio mercantil
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.folio_mercantil }}
                </span>
                en el Registro Público de la Propiedad y de Comercio de
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.municipio_registro }},
                </span>
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.estado_registro }},
                </span>
                obligándose bajo los términos que se establecen en el Contrato.
                <br />
              </span>
              <span class="ft12 text-justify">
                b. Su Representante cuenta con los poderes y facultades suficientes para celebrar el presente Contrato de
                Préstamo Mercantil, los que a la fecha no le han sido revocados o limitados, como lo acredita con la
                Escritura Pública número
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.escritura_publica_reprecentante }}
                </span>,
                suscrita ante la fe del licenciado
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.escritura_licenciado_reprecentante }}
                </span>,
                Notario Público número
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.numero_notaria_reprecentante }}
                </span> de
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.municipio_notaria_reprecentante }},
                </span>
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.estado_notaria_reprecentante }},
                </span>
                de fecha
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.escritura_fecha_reprecentante }}.
                </span>
                <br />
              </span>
              <span class="ft12 text-justify">
                c. Manifiesta que es su voluntad recibir en Arrendamiento EL (LOS) BIEN (ES) objeto del presente Contrato,
                con las modalidades y en los términos establecidos en el mismo.
                <br />
              </span>
              <span class="ft12 text-justify">
                d. Que señala como domicilio convencional para recibir notificaciones, así como para efectos del presente
                contrato, el localizado en
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.calle_reprecentante }}</span>
                No.
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.numero_calle_reprecentante }}</span>
                COLONIA
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.colonia_reprecentante }},
                </span>
                CODIGO POSTAL
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.codigo_postal_reprecentante }},
                </span>
                DE LA POBLACION DE
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.municipio_reprecentante }},
                </span>
                MUNICIPIO DE
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.municipio_reprecentante }},
                </span>
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.estado_reprecentante }}.
                </span>.
                Del cual presenta en este acto copia simple del comprobante de domicilio que
                lo acredita; así mismo señala para los efectos del presente Contrato, el correo electrónico .
                <br /><br />
              </span>
            </span>

            <div v-if="data.tipoAbound || data.tipoAendorsement">
              <span class="ft12">
                III.- Declara el
                <span class="ft12Black">
                  “Deudor Solidario y Aval”:
                </span>
              </span>
              <div>
                <span class="ft12 text-justify" v-if="data.tipoAbound">
                  a.
                  <span class="ft9Black" v-bind:class="{ 'marca-obligado': data.showMarca }">
                    {{ data.nombre_obligado }}
                  </span>
                  Declara ser una persona física con actividad empresarial y/o
                  persona moral, y cuenta con plenas facultades para obligarse
                  conforme a los términos del presente Contrato, manifestando ser de
                  nacionalidad Mexicana, mayor de edad, con
                  Registro Federal de Contribuyentes
                  <span class="ft9Black" v-if="data.tipoAbound" v-bind:class="{ 'marca-obligado': data.showMarca }">
                    {{ data.RFC_Obligado }},
                  </span>
                  y Clave Única de Población
                  <span v-if="data.tipoAbound" class="ft9Black" v-bind:class="{ 'marca-obligado': data.showMarca }">
                    {{ data.CURP_Obligado }}
                  </span>
                  persona que se identifica con Credencial de Elector expedida
                  por el Instituto Nacional Electoral, misma que cuenta con el
                  número de folio.
                  <br />
                </span>
                <span class="ft12 text-justify" v-if="data.tipoAendorsement">
                  <span class="ft9Black" v-bind:class="{ 'marca-aval': data.showMarca }">
                    {{ data.nombre_aval }}
                  </span>
                  Declara ser una persona física con actividad empresarial y/o
                  persona moral, y cuenta con plenas facultades para obligarse
                  conforme a los términos del presente Contrato, manifestando ser de
                  nacionalidad Mexicana, mayor de edad, con
                  Registro Federal de Contribuyentes
                  <span v-if="data.tipoAendorsement">
                    <span class="ft12Black "><span class="ft9Black" v-bind:class="{ 'marca-aval': data.showMarca }">
                        {{ data.RFC_aval }}
                      </span></span> </span>, y Clave Única de Población
                  <span v-if="data.tipoAendorsement" class="ft9Black" v-bind:class="{ 'marca-aval': data.showMarca }">
                    {{ data.CURP_aval }},
                  </span>
                  persona que se identifica con Credencial de Elector expedida
                  por el Instituto Nacional Electoral, misma que cuenta con el
                  número de folio.
                  <br />
                </span>
              </div>
              <span class="ft12 text-justify">
                b. Tener solvencia patrimonial, económica y moral para cubrir con
                las obligaciones derivadas del presente Contrato y las que por ley
                se deducen.
                <br />
              </span>
              <span class="ft12 text-justify">
                c. Manifiesta que es su voluntad obligarse en lo personal, de
                forma solidaria respecto de los deberes y obligaciones adquiridas
                en el presente Contrato por parte del “Arrendatario”.
                <br />
              </span>
            </div>
          </div>
        </div>
        <footer class="footer">
          <div class="col-12">
            <span class="ft12Black text-center">
              2
            </span>
          </div>
        </footer>
      </div>
      <div id="page3-div" class="container interline border page-container p-4">
        <span v-if="data.tipoAbound || data.tipoAendorsement" class="ft12 text-justify">
          d. Que señala como domicilio convencional para recibir
          notificaciones, así como para efectos del presente contrato,
          <div v-if="data.tipoAbound">
            <span class="ft12Black" v-bind:class="{ 'marca-obligado': data.showMarca }">
              {{ data.nombre_obligado }}
            </span>
            localizado en CALLE
            <span v-bind:class="{ 'marca-obligado': data.showMarca }">
              {{ data.calle_obligado }}
            </span>
            No.
            <span v-bind:class="{ 'marca-obligado': data.showMarca }">
              {{ data.numero_calle_obligado }}</span>
            COLONIA
            <span v-bind:class="{ 'marca-obligado': data.showMarca }">
              {{ data.colonia_obligado  }},
            </span>
            CODIGO POSTAL
            <span v-bind:class="{ 'marca-obligado': data.showMarca }">
              {{ data.codigo_postal_obligado }}, </span>DE LA POBLACION DE
            <span v-bind:class="{ 'marca-obligado': data.showMarca }">
              {{ data.municipio_obligado }}, </span>MUNICIPIO DE
            <span v-bind:class="{ 'marca-obligado': data.showMarca }">
              {{ data.municipio_obligado }}, </span><span v-bind:class="{ 'marca-obligado': data.showMarca }">
              {{ data.estado_obligado }}.
            </span>
          </div>
          <div v-if="data.tipoAendorsement">
            <span class="ft12Black" v-bind:class="{ 'marca-aval': data.showMarca }">
              {{ data.nombre_aval }}
            </span>
            localizado en CALLE
            <span v-bind:class="{ 'marca-aval': data.showMarca }">
              {{ data.calle_cliente }}
            </span>
            No.
            <span v-bind:class="{ 'marca-aval': data.showMarca }">
              {{ data.numero_calle_cliente }}</span>
            COLONIA
            <span v-bind:class="{ 'marca-aval': data.showMarca }">
              {{ data.colonia_cliente }},
            </span>
            CODIGO POSTAL
            <span v-bind:class="{ 'marca-aval': data.showMarca }">
              {{ data.codigo_postal_cliente }}, </span>DE LA POBLACION DE
            <span v-bind:class="{ 'marca-aval': data.showMarca }">
              {{ data.municipio_cliente }}, </span>MUNICIPIO DE
            <span v-bind:class="{ 'marca-aval': data.showMarca }">
              {{ data.municipio_cliente }}, </span><span v-bind:class="{ 'marca-aval': data.showMarca }">
              {{ data.estado_cliente }}.
            </span>
          </div>
          Del cual presenta en este acto copia simple del comprobante de
          domicilio que lo acredita; así mismo señala para los efectos del
          presente Contrato, el correo electrónico. <br /><br />
        </span>
        <span class="ft12">
          <span class="ft12" v-if="data.tipoABasic & !data.tipoAbound
            & !data.tipoAendorsement & !data.tipoAbout">
            III.- Declara el
          </span>
          <span class="ft12" v-if="data.tipoAbound || data.tipoAendorsement || data.tipoAbout">
            IV.- Declara el
          </span>
          <span class="ft12Black ">“Depositario”</span>:<br />
        </span>
        <span class="ft12 text-justify">a. Ser una persona física con actividad empresarial y/o persona
          moral, y cuenta con plenas facultades para obligarse conforme a
          los términos del presente Contrato, manifestando ser de
          nacionalidad Mexicana, con Registro Federal de Contribuyentes
          <span class="ft11" v-bind:class="{ marca: data.showMarca }">
            {{ data.RFC }}
          </span>
          <br />
        </span>
        <span class="ft12 text-justify">b. Tener solvencia patrimonial, económica y moral para cubrir con
          las obligaciones derivadas del presente Contrato y las que por ley
          se deducen.
          <br />
        </span>
        <span class="ft12 text-justify">c. Manifiesta que es su voluntad recibir como depositario EL (LOS)
          BIEN (ES) objeto del presente Contrato, con las modalidades y en los
          términos establecidos en el mismo.
          <br />
        </span>
        <span class="ft12 text-justify">
          d. Que señala como domicilio convencional para recibir notificaciones,
          así como para efectos del presente contrato, el localizado en CALLE
          <span v-bind:class="{ marca: data.showMarca }">
            {{ data.calle_cliente }}</span>
          No.
          <span v-bind:class="{ marca: data.showMarca }">
            {{ data.numero_calle_cliente }}</span>
          COLONIA
          <span v-bind:class="{ marca: data.showMarca }">
            {{ data.colonia_cliente }},
          </span>
          CODIGO POSTAL
          <span v-bind:class="{ marca: data.showMarca }">
            {{ data.codigo_postal_cliente }},
          </span>
          DE LA POBLACION DE
          <span v-bind:class="{ marca: data.showMarca }">
            {{ data.municipio_cliente }},
          </span>
          MUNICIPIO DE
          <span v-bind:class="{ marca: data.showMarca }">
            {{ data.municipio_cliente }},
          </span>
          <span v-bind:class="{ marca: data.showMarca }">
            {{ data.estado_cliente }}. </span> Del cual presenta en este acto copia simple del comprobante de
          domicilio que lo acredita.
          <br />
        </span>
        <div class="col-12 text-justify content-wrap"></div>
        <div class="col-12 text-center">
          <span class="ft13Black border-bottom border-dark">
            <br />CLÁUSULAS <br />
          </span>
        </div>
        <div class="col-12">
          <span class="ft12Black ">I.- OBJETO DEL CONTRATO.</span><br />

          <span class="ft12 text-justify">El “Arrendador” otorga en arrendamiento al “Arrendatario”, y ese
            último acepta, los bienes que se detallan a continuación:
            <br /><br />
          </span>
          <span class="ft12 text-justify">Un vehículo nuevo / usado: <br /><br />
          </span>
          <span class="ft12Black text-justify">Marca/tipo:<span v-bind:class="{ marca: data.showMarca }" class="ft11">
              {{ data.marca_vehiculo }}
            </span>
            <br />
          </span>
          <span class="ft12Black text-justify">Versión:<span v-bind:class="{ marca: data.showMarca }" class="ft11">
              {{ data.año_vehiculo }},
            </span>
            <br />
          </span>
          <span class="ft12Black text-justify">Modelo:<span v-bind:class="{ marca: data.showMarca }" class="ft11">
              {{ data.modelo_vehiculo }}
            </span>
            <br />
          </span>
          <span class="ft12Black text-justify">Número de Serie:<span v-bind:class="{ marca: data.showMarca }"
              class="ft11">
              {{ data.numero_serie_vehiculo.toUpperCase() }}
            </span>
            <br />
          </span>
          <span class="ft12Black text-justify">Motor:<span v-bind:class="{ marca: data.showMarca }" class="ft11">
              {{ data.numero_motor_vehiculo.toUpperCase() }}
            </span>
            <br /><br />
          </span>
          <span class="ft12 text-justify">Se regirían también por este Contrato, cualquier mecanismo,
            refacciones o piezas que se usen accesoriamente o que posteriormente
            se agreguen a los bienes arrendados. <br /><br />
          </span>
          <span class="ft12 text-justify">El “Arrendatario” ha elegido en forma unilateral y de conformidad
            con sus intereses el bien objeto del presente Contrato. <br /><br />
          </span>
          <span class="ft12 text-justify">El “Arrendador” señala que tiene la propiedad y/o el derecho real
            del objeto antes señalado, o en su caso, que va a adquirir el objeto
            materia del presente Contrato. <br /><br />
          </span>
          <span class="ft12 text-justify">La factura y/o el documento que ampara la propiedad y/o el derecho
            real del objeto (objetos) arrendados, siempre quedará en poder del
            “Arrendador” como legítimo propietario del objeto materia del
            presente Contrato. <br /><br />
          </span>
          <span class="ft12 text-justify">El “Arrendatario” conoce que el bien arrendado es propiedad y/o
            derecho real del “Arrendador”, por lo que se obliga a no hacer nada
            que pudiera afectar sus derechos de propiedad. El “Arrendatario” no
            podrá constituir o consentir a que se grave o limite el dominio del
            bien objeto del presente Contrato. <br /><br />
          </span>
          <span class="ft12 text-justify">La entrega del bien arrendado deberá hacerse constar mediante la
            firma de recibido de el “Arrendatario” en carta por separado, en la
            que también se deberán identificar los bienes arrendados; dicha
            carta deberá ser entregada a el “Arrendador” y forma parte del
            presente Contrato, relacionando la misma como Acuse de entrega de
            impuesto vehicular. <br /><br />
          </span>
          <span class="ft12">
            <span class="ft12Black ">II.- TÉRMINO DEL CONTRATO, RENTA Y PAGO</span>:<br />
          </span>
          <span class="ft12 text-justify">a. El término del presente Contrato será de:
            <span class="ft12Black" v-bind:class="{ marca: data.showMarca }">
              {{ data.plazo }} meses,
            </span> contados a
            partir de la fecha de firma del presente Contrato y sus efectos no
            terminarán sino cuando estén totalmente cumplidas las obligaciones
            que ambas partes asumen en el presente Contrato.
            <br />
          </span>
          <span class="ft12 text-justify">b. El plazo que se establece no podrá prorrogarse a menos que
            exista consentimiento por escrito de ambas partes, renunciando al
            efecto el “Arrendatario” a los beneficios del artículo 2143 del
            Código Civil para el Estado de Jalisco y su correlativo del Código
            Civil del Distrito Federal.
            <br />
          </span>
          <span class="ft12 text-justify">c. Al término del presente Contrato, el “Arrendatario” deberá
            devolver a el “Arrendador” el bien arrendado señalado en la cláusula
            que antecede en las mismas condiciones que lo recibió, con solo el
            desgaste causado por su uso normal de acuerdo a su naturaleza, ya
            que si tuviera algún daño, desperfecto o mal funcionamiento, o le
            faltare alguna pieza, tendrá el “Arrendatario” que cubrir su
            reparación y/o reposición, según sea el caso, conforme el avalúo que
            al efecto realice el “Arrendador” al recibir el bien.
            <br />
          </span>
          <span class="ft12 text-justify">En caso de que las reparaciones sean cubiertas por el “Arrendador”,
            el “Arrendatario” deberá reintegrar su importe al momento que se le
            solicite el “Arrendador”, debiendo cubrir en caso de falta de
            reembolso oportuno, un interés igual al que se estipula en la
            Cláusula XIX del presente Contrato, desde la fecha en que fuera
            requerido y hasta la fecha de su liquidación.
            <br />
          </span>

        </div>
        <footer class="footer">
          <div class="col-12">
            <span class="ft12Black text-center">
              3
            </span>
          </div>
        </footer>
      </div>
      <div id="page4-div" class="container interline border page-container p-3">
        <div class="col-12 text-justify content-wrap">
          <div class="col-12">
            <div class="text-justify">
              <span class="ft12 text-justify">
                d. El “Arrendatario” no tendrá derecho alguno a mantener la
                posesión del bien arrendado una vez concluido el plazo del presente
                Contrato, tampoco para el caso de que se incumpla con el pago de dos
                o más rentas mensuales, por lo que se compromete en cualquiera de
                los supuestos señalados expresamente a la devolución del bien
                arrendado en los términos del Código Civil para el Estado de
                Jalisco, a más tardar el día 61 natural en el domicilio del
                “Arrendador”, contados a partir del día en que incurrió en mora, por
                lo que cualquier posesión que mantenga será ilícita y dolosa de su
                parte, autorizando expresamente a el “Arrendador” a recoger dicho
                bien en el lugar en que se encuentre por propio derecho o mediante
                el apoyo de las autoridades competentes.
                <br />
              </span>
              <span class="ft12 text-justify">
                e. En caso de que el “Arrendatario” no devuelva a el “Arrendador”
                el bien al término del Contrato, deberá cubrir rentas que serán
                iguales a dos veces el importe del último pago de renta mensual
                señalado dentro del Contrato, por todo el tiempo que mantenga en su
                poder los bienes arrendados. La renta se cobrará por mes completo
                invariablemente del día del mes que devuelva el bien. La devolución
                del bien objeto del presente Contrato tendrá lugar en el domicilio
                del “Arrendador” señalado en la Declaración I, inciso c., o en su
                caso, en el domicilio que previamente notifique por escrito por
                cualquier medio el “Arrendador” al “Arrendatario”.
              </span>
              <span class="ft12 text-justify"><br />f. Los pagos por concepto de renta de los bienes
                arrendados serán considerados como una renta unitaria definitiva
                no reembolsable, tal como se indica en el
                <span class="ft12Black text-justify">Pagare</span>, dichos pagos
                deberán ser mensuales y consecutivos, pagaderos cada uno de
                ellos el día calendario de cada periodo.
                <br />
              </span>
              <span class="ft12">
                g. En el entendido que el Pagare que forma parte integral del
                presente Contrato, firmado por las partes comparecientes,
                contiene fechas de pago, número de rentas por pagar e importe de
                pagos de rentas.<br />
              </span>
              <span class="ft12">
                h. Dichos pagos por concepto de renta deberán ser efectuados por
                el “Arrendatario” en la siguiente cuenta bancaria a través de
                transferencia electrónica o depósito:<br />
              </span>
            </div>
            <span class="ft12 text-justify">
              <span class="ft12Black">BANORTE CONVENIO CIE: </span>
              5524
              <span class="ft12Black">CUENTA:</span>
              0420253088
              <span class="ft12Black">CLABE INTERBANCARIA</span>
              072320004202530888,
              con número de referencia
              <span  v-bind:class="{ marca: data.showMarca }" class="ft12Black">{{ data.referencia_banco }}</span>
              Así mismo, el pago podrá ser realizado en
              el domicilio del “Arrendador” señalado en las Declaraciones del
              presente Contrato.<br />
            </span>
            <span class="ft12 text-justify">
              i. El “Arrendatario” cubrirá dichos pagos por concepto de renta
              durante el término del Contrato, considerándose ellos como plazos
              para el pago, en los términos del artículo 2005 del Código Civil
              para el Estado de Jalisco y su correlativo del Código Civil para
              el Distrito Federal. El primer pago deberá hacerse el día
              <span v-bind:class="{ marca: data.showMarca }">
                {{ data.fecha_primer_pago }}
              </span>
              y los ulteriores pagos el día
              <span v-bind:class="{ marca: data.showMarca }">
                {{ data.dias_de_abono }}</span>de cada mes<br />
            </span>
            <span class="ft12 text-justify">
              j. Si una fecha de vencimiento establecida de conformidad con ese
              Contrato coincide con un día hábil, el “Arrendatario” se obliga a
              efectuar el pago respectivo el día hábil inmediato anterior. Para
              efectos de ese párrafo, por día hábil se entenderá el día en que
              los Bancos estén abiertos para efectuar transacciones en la
              <span class="ft12Black text-justify">Ciudad de Guadalajara, Jalisco.</span><br />
            </span>
            <span class="ft12 text-justify">
              k. El “ARRENDATARIO” entrega, en el momento de firmar este
              Contrato la cantidad de
              <span class="ft12Black" v-bind:class="{ marca: data.showMarca }">
                ${{ data.mensualidad }} {{ data.mensualidad_letra }}
              </span>
              más I.V.A. correspondiente a una
              <span class="ft12Black text-justify">Renta en Garantía</span>,
              cantidad que no generará interés alguno a favor del
              “Arrendatario”. Esta suma será aplicable al último pago por
              concepto de una renta estipulada para el plazo forzoso de este
              Contrato. El “Arrendador” queda autorizado para retener dicha suma
              hasta que el “Arrendatario” de cumplimiento a todas y cada una de
              las obligaciones y responsabilidades derivadas de este
              Contrato.<br />
            </span>
            <span class="ft12">
              l. El “Arrendatario” entrega adicionalmente, en el momento de
              firmar el presente Contrato la cantidad de,
              <span class="ft12Black" v-bind:class="{ marca: data.showMarca }">
                ${{ data.enganche }} {{ data.enganche_letra }}
              </span>
              correspondiente a un
              <span class="ft12Black ">Depósito Adicional en Garantía </span>
              cantidad que no generará interés alguno a favor del
              “Arrendatario”.<br />
            </span>
            <span class="ft12 text-justify">Esta suma será aplicable a cualquier adeudo vencido con una
              antigüedad mayor de 60 días. El “Arrendador” queda autorizado para
              retener dicha suma hasta que el “Arrendatario” de cumplimiento a
              todas y cada una de las obligaciones y responsabilidades derivadas
              de este Contrato.
              <br />
            </span>
            <span class="ft12 text-justify">m. Si el “Arrendador” así lo solicita, el “Arrendatario” asume la
              obligación de firmar uno o tantos pagarés como pagos principales
              que por concepto de renta deban cubrirse, en consecuencia, el
              “Arrendatario” autoriza a el “Arrendador” para que pueda endosar
              en propiedad, procuración o garantía, así como para transmitir,
              gravar o negociar los pagarés en la forma que considere necesario.
              Ambas partes convienen en que la suscripción y entrega de esos
              títulos, no implica el pago de la renta, ni constituye recibo de
              ella, dichos pagarés se emiten tan solo como garantía del
              cumplimiento de las obligaciones a cargo de el “Arrendatario”.
              <br />
            </span>
            <span class="ft12 text-justify">n. En caso de falta de pago puntual por parte de él
              “Arrendatario”, el “Arrendador” podrá exigir el pago total del
              saldo insoluto, sin perjuicio de la facultad que tiene de
              rescindir el presente Contrato, pudiendo en su caso ejercitar las
              acciones que correspondan ya sea con el pagaré o con el Contrato
              que nos ocupa, esto a su elección.
              <br />
            </span>
            <span class="ft12 text-justify">o. El “Arrendatario” está de acuerdo en que el “Arrendador” podrá
              determinar la terminación anticipada del presente Contrato sin
              necesidad de declaración judicial alguna en caso de incumplimiento
              por parte del “Arrendatario” con cualquiera de las obligaciones a
              las que se encuentra sujeto con motivo del presente Contrato.
              <br />
            </span>
            <span class="ft12">
              p. En caso de la terminación anticipada del Contrato, el
              “Arrendatario” deberá devolver al “Arrendador” el bien objeto del
              presente Contrato dentro de los 2 días naturales posteriores a que
              el “Arrendador” le haya notificado la causa de terminación del
              Contrato.<br /><br />
            </span>
            <span class="ft12Black ">III. ENTREGA.</span><br />
            <span class="ft12 text-justify">El “Arrendatario” manifiesta que ha elegido en forma individual y
              directamente del distribuidor o proveedor, los bienes arrendados,
              asumiendo cualquier riesgo al respecto, por ser de su entera
              satisfacción. El “Arrendador”, por lo tanto, no asume
              responsabilidad alguna ante el "Arrendatario" de cualquier daño,
              pérdida, defecto, entrega tardía, errores en la entrega, o
              diferencia en las especificaciones de los bienes objeto del
              arrendamiento, o por cualquier otro error o incumplimiento del
              fabricante, distribuidor o transportista en la entrega, ensamble o
              instalación de dichos bienes. En virtud de lo anterior, el
              “Arrendatario” expresa su conformidad en que el “Arrendador” no
              será responsable por pérdida, daño o gasto de cualquier
              naturaleza, causado directa o indirectamente por los bienes
              arrendados o por las deficiencias que pudieran tener en su caso u
              operación los bienes arrendados mencionados. <br /><br />
            </span>
          </div>
        </div>
        <footer class="footer">
          <div class="col-12">
            <span class="ft12Black text-center">
              4
            </span>
          </div>
        </footer>
      </div>
      <div id="page5-div" class="container interline border page-container p-3">
        <div class="col-12 text-justify content-wrap">
          <div class="col-12">
            <div class="text-justify">
              <span class="ft12 text-justify">
                En el caso de presentar algún problema derivado de alguno de los
                supuestos contenidos en la cláusula anterior el “Arrendatario
                “queda plenamente facultado por el “Arrendador” para que efectúe
                las reclamaciones procedentes ante el fabricante, distribuidor o
                transportista, según corresponda, excluyendo a el “Arrendador” de
                cualquier responsabilidad al respecto. <br /><br />
              </span>
              <span class="ft12 text-justify">
                EI “Arrendatario” se obliga a recibir el (los) bien (es)
                arrendado(s) directamente del fabricante o distribuidor,
                obligándose el “Arrendador” a entregar a al “Arrendatario” los
                documentos necesarios para que ésta última quede legitimada a fin
                de recibirlos directamente.
                <br /><br />
              </span>
              <span class="ft12 text-justify">
                EI “Arrendatario” entiende y manifiesta de forma expresa que
                cualquier modificación o alteración que realice al bien
                originalmente adquirido del fabricante, puede anular la garantía y
                las coberturas de la póliza de seguro inclusive, por lo cual asume
                como suya la responsabilidad correspondiente. <br />
              </span>
              <span class="ft12">
                <br />En el supuesto de que el "Arrendatario" solicite la
                adecuación o instalación de accesorios distintos a los que el
                vehículo trae consigo de fábrica, o bien, que solicite la
                modificación de cualquier accesorio o dispositivo que forme
                parte del mismo, será bajo su más estricta responsabilidad,
                subsistiendo la obligación de recibir la unidad arrendada aún y
                cuando haya solicitado al proveedor la reparación o
                modificaciones de dichas instalaciones solicitadas. El
                “Arrendador” cumple con su obligación en el momento en que pone
                a disposición del “Arrendatario” la unidad arrendada por haberlo
                adquirido en virtud de la instrucción de esa última. Las
                modificaciones señaladas en este párrafo deberán ser solicitadas
                al “Arrendador” y autorizadas siempre por escrito, las cuales
                una vez autorizadas, serán parte integral de la unidad arrendada
                y a la devolución del mismo, no serán devueltas a el
                “Arrendatario”. <br />
              </span>
              <span class="ft12">
                Queda entendido que la recepción de bienes por parte del
                “Arrendatario” no excederá los 30 (treinta) días a partir de la
                fecha de la firma del presente Contrato. En caso contrario se
                dará por terminado el presente Contrato y el “Arrendatario” se
                obliga a restituir a el “Arrendador” cualquier pago que hubiera
                hecho al fabricante o distribuidor de los bienes objeto del
                presente Contrato de Arrendamiento Puro. Igualmente, el
                “Arrendatario” se obliga a recibir dichos bienes en el siguiente
                domicilio o en el domicilio del fabricante o distribuidor:<br />
                CALLE
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.calle_cliente }}</span>
                No.
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.numero_calle_cliente }}</span>
                COLONIA
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.colonia_cliente }},
                </span>
                CODIGO POSTAL
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.codigo_postal_cliente }},
                </span>
                DE LA POBLACION DE
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.municipio_cliente }},
                </span>
                MUNICIPIO DE
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.municipio_cliente }},
                </span>
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.estado_cliente }}.
                </span>.
              </span>
            </div>
            <span class="ft12 text-justify">
              El “Arrendatario” queda obligado a cubrir los gastos que se
              originen o pudieran originarse con motivo de la entrega de los
              bienes arrendados tales como transporte, almacenamiento, fletes o
              de cualquier otro similar. Son igualmente por cuenta del
              “Arrendatario” la totalidad de los gastos derivados de la
              instalación, funcionamiento, conservación y mantenimiento de los
              bienes objeto de este arrendamiento.<br />
            </span>
            <span class="ft12 text-justify">
              Si el “Arrendatario” se negara a recibir el equipo objeto del
              arrendamiento, una vez que haya formalizado su pago inicial, se
              obliga a pagar a el “Arrendador” por concepto de indemnización,
              una suma equivalente al 16% (diez y seis por ciento) del importe
              de la factura total del bien arrendado, obligándose así mismo a
              reintegrarle a el “Arrendador” cualquier pago o anticipo que este
              hubiere entregado al vendedor o distribuidor del equipo en
              relación con este arrendamiento.

              <br /><br />
            </span>
            <span class="ft12 text-justify">
              <span class="ft12Black text-justify">IV. CUIDADO DE OPERACIÓN. </span><br />
            </span>
            <span class="ft12 text-justify">
              A fin de que los bienes motivo del arrendamiento durante la
              vigencia de este Contrato, sufran exclusivamente el deterioro
              causado por su funcionamiento en condiciones normales de acuerdo
              con su naturaleza y destino, el “Arrendatario” se obliga a tomar
              las medidas necesarias y efectuar los actos que para ello se
              requieran y en especial lo siguiente:<br />
            </span>
            <span class="ft12">
              &emsp;&emsp;a. A utilizar la unidad arrendada únicamente dentro de
              su capacidad normal y sin abuso del mismo, y conservándolo en el
              &emsp;&emsp; estado que permita el uso normal que le corresponde y
              dar el mantenimiento a su costa necesario para tal efecto, sin que
              &emsp;&emsp; lo anterior implique cualquier cambio en la
              naturaleza de la unidad arrendada o su menoscabo. <br />
            </span>
            <span class="ft12 text-justify">&emsp;&emsp;b. A cumplir con las especificaciones de
              funcionamiento y buen manejo, de acuerdo con el manual de
              operación, así como &emsp;&emsp;cumplir con los calendarios de
              mantenimiento que indica el fabricante para conservar la garantía
              correspondiente.
              <br />
            </span>
            <span class="ft12 text-justify">
              &emsp;&emsp;c. A emplear para su operación y manejo exclusivamente
              trabajadores calificados, contratados y controlados por su
              &emsp;&emsp;&emsp;cuenta.

              <br />
            </span>
            <span class="ft12 text-justify">&emsp;&emsp;d. A reponer durante el plazo del presente Contrato
              por los daños o perjuicios que se pudieran causar a el
              “Arrendador” &emsp;&emsp;con motivo de la falta de inmediata
              reparación en su caso del (los) bien(es) arrendado(s), puesto que
              se queda obligada a &emsp;&emsp;mantener dichos bienes siempre
              aptos para el servicio.
              <br />
            </span>
            <span class="ft12 text-justify">&emsp;&emsp;e. A efectuar, por su cuenta, todo tipo de servicios
              de mantenimiento y reparación, así como a dotarlos de las
              refacciones &emsp;&emsp;que sean necesarios para su debido
              mantenimiento y eficiencia durante la vigencia del presente
              contrato, conservándolos &emsp;&emsp;en condiciones óptimas de
              funcionamiento.
              <br />
            </span>
            <span class="ft12">
              &emsp;&emsp;f. A emplear exclusivamente refacciones legítimas
              hechas por el fabricante, salvo autorización que, en cada caso, le
              &emsp;&emsp;&emsp;proporcione previamente y por escrito el
              “Arrendador”.<br />
            </span>

            <span class="ft12 text-justify">&emsp;&emsp;g. A recibirlos en el domicilio del fabricante o
              distribuidor o en el domicilio señalado en la Cláusula III,
              domicilio en el cual &emsp;&emsp;deberá residir el Arrendatario
              durante todo el tiempo de la duración del Presente Contrato, a
              menos que lo notifique &emsp;&emsp;&emsp;previamente al Arrendador
              y éste lo autorice. <br />
            </span>
            <span class="ft12 text-justify">&emsp;&emsp;h. En el caso de que los bienes arrendados fueren
              vehículos, el “Arrendatario “se obliga a utilizar el objeto
              materia del &emsp;&emsp;presente Contrato exclusivamente dentro
              del territorio de la República Mexicana, en caso de que requiera
              utilizar el bien &emsp;&emsp;antes señalado en territorio
              internacional, deberá el “Arrendatario” obtener la autorización
              expresa por parte del &emsp;&emsp;&emsp;“Arrendador”. <br />
            </span>
            <span class="ft12 text-justify">&emsp;&emsp;i. En caso de que el “Arrendatario” utilice el bien
              objeto del presente Contrato en un Estado de la República Mexicana
              &emsp;&emsp;&emsp;distinto al del domicilio del “ARRENDATARIO”
              señalado en el presente Contrato por más de un mes, el
              “Arrendatario” &emsp;&emsp;deberá notificar al “Arrendador” y a su
              vez, deberá obtener la autorización por escrito por parte del
              “Arrendador”
              <br /><br />
            </span>
          </div>
        </div>
        <footer class="footer">
          <div class="col-12">
            <span class="ft12Black text-center">
              5
            </span>
          </div>
        </footer>
      </div>
      <div id="page6-div" class="container interline border page-container p-3">
        <div class="col-12 text-justify content-wrap">
          <div class="col-12">
            <span class="ft12Black text-justify">
              V. CESIÓN DE DERECHOS O GARANTÍA.
            </span>
            <span class="ft12 text-justify">
              El “Arrendador” queda expresamente autorizado, por si a sus
              intereses conviniere a ceder traspasar todo o partes de los
              derechos de este contrato, sea a una institución de crédito o
              cualquier persona física o moral, Asimismo el “Arrendador” podrá
              otorgar en garantía cualquiera que sea la forma, los derechos
              emanados del presente Contrato.<br />
            </span>
            <span class="ft12 text-justify">
              Expresamente convienen las partes en que al “Arrendatario” le
              queda prohibido ceder y/o traspasar los derechos y/u obligaciones
              nacidas del presente contrato. Tampoco podrá el “Arrendatario”
              vender, ceder, gravar o subarrendar en cualquier forma el objeto
              arrendado, ya sea en su totalidad o en parte de este.
            </span>
            <div class="text-justify">
              <span class="ft12">
                <br />
                Si el arrendatario violare en cualquier forma las
                prohibiciones a que se refiere el párrafo anterior, será causa
                de rescisión de este contrato de arrendamiento, y además cubrirá
                a el “Arrendador” los daños y perjuicios que le ocasione dicha
                violación. <br />
              </span>
              <span class="ft12">
                Asimismo, pactan en forma expresa que el “Arrendatario” no
                tendrá derecho alguno a mantener la posesión del bien arrendado
                por lo que se compromete en los términos del artículo 2124 del
                Código Civil para el Estado de Jalisco, a entregar el bien
                objeto del arrendamiento, a el “Arrendador” en el momento que se
                le requiera, autorizando expresamente a el “Arrendador” a
                recoger dicho bien en el lugar en que se encuentre, con o sin
                apoyo de las autoridades competentes.<br />
              </span>
            </div>
            <span class="ft12Black text-justify">
              <br />
              VI. LICENCIAS, PERMISOS Y REGISTROS.<br />
            </span>
            <span class="ft12 text-justify">
              Queda obligado expresamente el “Arrendatario” a obtener las
              licencias, permisos y demás documentación que se requiera o que se
              llegue a requerir de acuerdo con las leyes, reglamentos o
              circulares que sean aplicables al respecto, relativas a los bienes
              arrendados, así como a su funcionamiento, debiendo igualmente
              pagar por su cuenta todos los derechos, impuestos y erogaciones en
              general que por tal concepto deban ser liquidadas a las
              autoridades que correspondan durante la vigencia del presente
              Contrato.

              <br /><br />
            </span>
            <span class="ft12 text-justify">
              En caso de incumplimiento a lo dispuesto por los párrafos
              precedentes sin perjuicios de la facultad que tiene el
              “Arrendador” para rescindir el presente contrato, podrá pagar las
              sumas derivadas de los conceptos mencionados en el párrafo
              anterior por cuenta y orden del “Arrendatario”, cantidades que
              deberá reintegrar el Arrendatario a el “Arrendador”, en cuanto
              éste lo solicite. En caso de incumplimiento las cantidades que
              deba reintegrar el “Arrendatario”, causarán un interés igual al
              que se estipula en la cláusula XIX de este Contrato desde la fecha
              de incumplimiento hasta aquella en la que se efectúe el reintegro.

              <br />
            </span>
            <span class="ft12Black text-justify">
              <br />
              VII. IMPUESTOS Y OTROS GASTOS.<br />
            </span>
            <span class="ft12 text-justify">
              El “Arrendatario” conviene en pagar la totalidad de gastos,
              derechos e impuestos en vigor, así como los que en un futuro
              pudieran establecerse por cualquier autoridad respecto a la
              posesión, tenencia, propiedad, infracciones (ya sean federales,
              estatales o municipales), mantenimiento, uso y funcionamiento de
              los bienes arrendados, o cualquiera otra erogación que cause el
              presente Contrato, sea cual fuere su naturaleza, entendiéndose que
              el “Arrendador” no deberá efectuar erogación alguna por ningún
              concepto. Al efecto, el “Arrendatario” se obliga a entregar a el
              “Arrendador” copia de los comprobantes de pago de los conceptos
              mencionados dentro de las 24 horas siguientes a la fecha en que
              los realice.<br />
            </span>
            <span class="ft12">
              Para el caso de que el “Arrendador” reciba en su domicilio o que
              sea de su conocimiento por cualquier medio, de requerimientos de
              cobro por concepto de infracciones o multas a cargo del bien
              arrendado, el “Arrendador” queda autorizado para que pueda pagar a
              cargo del “Arrendatario”, obligándose esta última a reembolsar el
              pago realizado dentro de las 24 horas siguientes a su
              notificación. <br /><br />
            </span>
            <span class="ft12 text-justify">Si los bienes de este Contrato han sida importados, el
              "Arrendatario" se responsabiliza ante la Secretaría de Hacienda y
              Crédito Público, la Secretaría de Economía y/o cualquier otra
              dependencia, de cualquier requerimiento legal o reclamaciones que
              efectúen las mencionadas dependencias oficiales, relacionadas con
              el pago de los impuestos o derechos de importación
              correspondientes a los bienes materiales de este Contrato. Por lo
              anterior el "Arrendatario" libera, en la forma más amplia, al
              "Arrendador" de cualquier responsabilidad presente o futura
              relativa al pago de dichos impuestos o derechos.
              <br />
            </span>
            <span class="ft12 text-justify">
              Si por cualquier causa el "Arrendador" cubriera alguna cantidad
              derivada de lo estipulado en los párrafos, precedentes, el
              "Arrendatario" deberá reintegrársela en cuanto se lo solicite el
              "Arrendador”'.
              <br />
            </span>
            <span class="ft12 text-justify">En caso de incumplimiento, sin perjuicio de la facultad que tiene
              este último para rescindir el Contrato, la cantidad que el
              Arrendatario deba reintegrar a el Arrendador causará un interés
              igual al que se estipula en la Cláusula XIX de este Contrato,
              desde la fecha del incumplimiento hasta aquélla en que se haga el
              reintegro.
              <br />
            </span>
            <span class="ft12 text-justify">En el caso de que los mencionados impuestos, derechos, tarifas,
              etc., aplicables, sufran algún aumento en sus respectivos
              importes, el "Arrendatario" se obliga a depositar de inmediato
              ante el "Arrendador" la diferencia respectiva.
              <br />
            </span>
            <span class="ft12">
              El "Arrendatario" deberá pagar al "Arrendador" la totalidad del
              Impuesto al Valor Agregado, o cualquier variación de este, sobre
              el monto total de los pagos que por concepto de renta o comisión
              en el presente Contrato se estipulen.
              <br /><br />
            </span>

            <span class="ft12 text-justify">En caso que el “Arrendatario” no le reembolse al “Arrendador” los
              pagos realizados por los motivos y en los términos señalados en
              los párrafos que anteceden, el “Arrendador” podrá aplicar parte
              del monto pagado con motivo del arrendamiento del presente
              Contrato hasta en tanto no se cubra de manera total los adeudos
              generados, dejando así un insoluto al monto pagado para cubrir las
              rentas mensuales, mismo que generan un interés de conformidad a lo
              señalado en la cláusula XIX, ello sin perjuicio de la facultad que
              tiene el “Arrendador” para rescindir el Contrato. <br />
            </span>
            <span class="ft12Black text-justify"><br />VIII. INSPECCIÓN DEL EQUIPO. <br />
            </span>
            <span class="ft12 text-justify">El "Arrendador" tiene el derecho a inspeccionar el bien objeto
              del presente contrato cuantas veces lo desee. El "Arrendatario” se
              obliga a permitir dichas inspecciones, y en su caso a proveer a el
              “Arrendador”' del equipo y elementos necesarios para verificar la
              adecuada operación y conservación del equipo.

              <br /><br />
            </span>
          </div>
        </div>
        <footer class="footer">
          <div class="col-12">
            <span class="ft12Black text-center">
              6
            </span>
          </div>
        </footer>
      </div>
      <div id="page7-div" class="container interline border page-container p-3">
        <div class="col-12 text-justify content-wrap">
          <div class="col-12">
            <div class="text-justify">
              <span class="ft12Black">
                <br />IX. SISTEMA DE POSICIONAMIENTO GLOBAL (par sus siglas en
                inglés) GPS.<br />
              </span>
              <span class="ft12">
                Con el objeto de brindar seguridad y protección contra robo, el
                "Arrendatario" autoriza en este acto a el "Arrendador" para que
                a su elección pueda instalar, con cargo a el "Arrendatario",
                dispositivos de localización satelital (en adelante GPS) en la
                unidad arrendada. Acordando las partes que el "Arrendador”, se
                reserva el derecho de instalarlo o no, así como el monitoreo y
                el uso de la información que genere el dispositivo.<br />
              </span>
            </div>
            <span class="ft12 text-justify">
              La unidad arrendada contará con un GPS, que permite rastrearlo,
              ubicarlo e inmovilizarlo con fines de seguridad o en su caso con
              la finalidad de procurar la devolución del mismo, por lo que el
              "Arrendatario", respecto de tal sistema tiene las siguientes
              obligaciones; (I) NO modificar o alterar de forma alguna el
              dispositivo de localización o su funcionamiento; (II) asistir
              cuantas veces sea necesario o lo solicite el "Arrendador", ante el
              proveedor de tal sistema y/o servicio a efecto de instalar, dar
              mantenimiento y en su caso sustituir el dispositivo de referencia
              con la finalidad de que tal Sistema sea operable y se permita la
              localización de la unidad arrendada de forma permanente; (III)
              realizar cualquier acto que permita la operatividad de tal Sistema
              y la localización de la unidad arrendada de forma permanente; y
              (IV) acatar las disposiciones que se especifican en la carta de
              GPS que se entrega a la firma del contrato.<br />
            </span>
            <span class="ft12 text-justify">
              Convienen las Partes en que para efectos de acreditar ya sea el
              cumplimiento o incumplimiento de las obligaciones establecidas en
              esta cláusula, bastará el informe que para tal efecto rinda el
              tercero prestador y/o proveedor del servicio de GPS, de tal suerte
              que expresamente se someten al informe que rinda dicho tercero
              prestador del servicio en el que indique si el Sistema se
              encuentra operando o no.<br />
            </span>

            <span class="ft12">
              La sola omisión a lo dispuesto en la presente cláusula dará lugar
              a la terminación anticipada del contrato por causas imputables al
              “Arrendatario”, en caso de que éste fuese responsable de dicha
              omisión, ello sin necesidad de aviso, trámite o procedimiento
              previo. <br />
            </span>
            <span class="ft12 text-justify">Así mismo, en caso de omisión, creará la presunción de ilicitud
              en el traslado, posesión y/o uso de la unidad arrendada, por lo
              que el "Arrendador" con independencia de las demás acciones que de
              tal incumplimiento se deriven, quedará facultado a ejercitar todas
              las acciones legales a su alcance, inclusive las de carácter penal
              que pudieran corresponder para obtener la recuperación de la
              unidad arrendada.
              <br />
            </span>
            <span class="ft12 text-justify">El “Arrendatario” conoce y acepta la colocación del dispositivo
              GPS, por lo que la modificación, alteración, retiro o intento de
              retiro de dicho dispositivo de localización se considera mala fe
              por parte del “Arrendatario”. <br /><br />
            </span>
            <span class="ft12Black text-justify">X. SEGUROS.
              <br />
            </span>
            <span class="ft12 text-justify">Serán por cuenta exclusiva de el "Arrendatario" todos los
              riesgos, pérdida, robo, destrucción y daños en general que sufran
              los bienes arrendados, mismos que se detallan en la Cláusula I
              (primera), así coma los daños y perjuicios que se ocasionen o
              pudieran ocasionar a terceros en su persona o en sus propiedades.
              <br />
            </span>
            <span class="ft12">
              En cumplimiento a la obligación contenida en el párrafo anterior,
              el "Arrendador" queda facultado para contratar las Pólizas de
              Seguro que fueren necesarias para cubrir a su entera satisfacción
              y con cobertura amplia los bienes objeto del presente instrumento,
              por el uso, tenencia o goce de estos por un término no menor al de
              la duración del presente Contrato. En el evento de que, por así
              convenir a ambas partes, el "Arrendatario" contratará la Póliza
              aquí mencionada, en todo momento deberá designarse a él
              "Arrendador" como beneficiario preferente en forma irrevocable.
              Dichos seguros deberán ser contratados con la Institución o
              Instituciones que el "Arrendador" autorice.<br />
            </span>
            <span class="ft12 text-justify">El "Arrendatario" deberá reintegrar a el "Arrendador”, la
              totalidad de gastos que haya efectuado por la Póliza de Seguro,
              debiendo cubrir, además, en caso de falta de reembolso oportuno,
              un cargo igual al que se estipula en la cláusula XIX de este
              Contrato, a partir de la fecha en que el "Arrendador”, le haya
              solicitado el reintegro, hasta su total liquidación.

              <br />
            </span>
            <span class="ft12 text-justify">Las pólizas de los seguros respectivos deberán quedar en poder
              del "Arrendador" y dichos seguros deberán mantenerse vigentes
              durante toda la vigencia del presente Contrato, por lo que en su
              caso el "Arrendador" renovará periódicamente las pólizas a su
              vencimiento, con cargo a el "Arrendatario". <br />
            </span>
            <span class="ft12 text-justify">El "Arrendatario" se obliga a reintegrar la totalidad de gastos
              en que incurra el "Arrendador" con motivo de un siniestro,
              inclusive el deducible, multas, gestiones, viáticos, avisos y
              demás actos que se requieran a fin de que, en caso de pérdida,
              robo, destrucción o de cualquier daño que sufran los bienes
              arrendados, puedan realizarse en forma expedita los trámites
              necesarios ante la Institución Aseguradora que corresponda, para
              lograr la indemnización que proceda, debiendo colaborar
              ilimitadamente con el "Arrendador" para tal efecto, pactándose
              expresamente que la renta se seguirá causando y serán cargo de él
              "Arrendatario" hasta que el "Arrendado”' reciba el pago del bien
              arrendado por parte de la institución Aseguradora. <br />
            </span>
            <span class="ft12 text-justify">En el supuesto de que por causa de un siniestro o por cualquier
              otra causa el “ARRENDATARIO” se encuentre impedido temporalmente
              de utilizar el bien objeto del presente Contrato, el
              “ARRENDATARIO” tendrá la obligación de pagar el monto
              correspondiente con motivo del presente Contrato y no podrá
              solicitar la terminación del mismo. <br />
            </span>
            <span class="ft12Black text-justify"><br />XI. PÉRDIDA O DAÑO. <br />
            </span>
            <span class="ft12 text-justify"><br />En caso de que ocurriese cualquier siniestro a los bienes
              objeto del Contrato, por el que se cause la pérdida, destrucción,
              daño o cualquier otra contingencia que impida su uso parcial o
              total, las partes convienen en que regirán los siguientes términos
              y condiciones:<br /><br />
            </span>
            <div class="ml-3 col-12">
              <span class="ft12 text-justify">a. En caso de que la unidad amparada en este Contrato sufra
                pérdida total o robo, el Contrato seguirá vigente y se dará por
                terminado sólo hasta en el momento en que la Institución
                Aseguradora pague la indemnización correspondiente a el
                "Arrendador”, por lo que subsiste la obligación para el
                "Arrendatario" de cubrir el deducible que cobre la Institución
                Aseguradora, así como las rentas generadas hasta el momento del
                pago.<br />
              </span>
            </div>
          </div>
        </div>
        <footer class="footer">
          <div class="col-12">
            <span class="ft12Black text-center">
              7
            </span>
          </div>
        </footer>
      </div>
      <div id="page8-div" class="container interline border page-container p-3">
        <div class="col-12 text-justify content-wrap">
          <div class="col-12">
            <div class="ml-3 col-12">
              <div class="">
                <span class="ft12">
                  <br />b. En caso de existir varios equipos arrendados y alguno
                  de ellos sufre pérdida total o robo, se cancelará parcialmente
                  el Contrato desde el momento en que la Institución Aseguradora
                  haya efectuado el pago de la indemnización a el "Arrendador",
                  subsistiendo la obligación mencionada en el párrafo anterior
                  para el "Arrendatario" de cubrir el deducible que cobró la
                  Institución Aseguradora, así corno las rentas generadas hasta
                  el momento del pago y continuará vigente el mismo respecto de
                  los demás bienes, disminuyéndose desde luego el monto de las
                  rentas en las proporciones conducentes.<br />
                </span>
                <span class="ft12">
                  c. En el supuesto de que, a la fecha de la indemnización del
                  seguro, existan uno o más pagos periódicos vencidos y no
                  pagados, el importe de la indemnización se aplicará
                  íntegramente a la liquidación de tales pagos periódicos
                  vencidos y no pagados, o a cualquier otro gasto o impuesto que
                  se deba a el "Arrendador", quedando a salvo el derecho de el
                  "Arrendador" para exigir el pago de tales conceptos en caso de
                  que el "Arrendatario" no cubra los adeudos pendientes, el
                  "Arrendador" se reserva el derecho de rescindir o continuar el
                  Contrato.<br />
                </span>
              </div>
              <span class="ft12 text-justify">
                d. En caso de que fuera posible la reparación del bien, que
                permita nuevamente su uso o funcionamiento, el importe de la
                indemnización del seguro se aplicará a su restauración, hasta
                donde alcance, obligándose a cubrir el "Arrendatario" el
                faltante si lo hubiese. En este caso el "Arrendatario" quedará
                obligado también al pago de las rentas periódicas no obstante
                que, por causa de reparación de los bienes arrendados, no pueda
                seguir haciendo uso temporal de los mismos. <br />
              </span>
              <span class="ft12 text-justify">
                e. En caso de que la indemnización del seguro no cubriera el
                valor de rescate neto según lo establece el "Anexo 3", el
                "Arrendador" podrá aplicar el Depósito Adicional en Garantía, y
                en caso de haber excedente se reintegrará a el "Arrendatario" la
                cantidad correspondiente y en el supuesto de que hubiera un
                faltante para saldar el valor de rescate neto, esta cantidad
                será exigible por el "Arrendador” al “Arrendatario".<br />
              </span>

              <span class="ft12">
                f. En caso de que la unidad objeto de este contrato sufra
                pérdida total o robo, única y exclusivamente dentro del periodo
                del presente contrato, no habrá necesidad de sustituir ésta,
                siempre y cuando se encuentre la unidad asegurada por el
                "Arrendador", con la compañía aseguradora autorizada, y de
                acuerdo a las condiciones contratadas en la póliza vigente al
                momento del siniestro, obligándose el "Arrendatario" a cubrir la
                diferencia que hubiera entre el nuevo precio de reposición de la
                unidad y el importe neto que pague la aseguradora por concepto
                del siniestro, una vez que haya realizado sus respectivas
                deducciones, en el entendido que los pagos de deducibles o
                coaseguros y demás gastos inherentes de la sustitución de la
                unidad son a cargo de el "Arrendatario".
                <br />
              </span>
            </div>
            <span class="ft12Black text-justify"><br />XII. LIBERACIÓN DE RESPONSABILIDAD.
              <br />
            </span>
            <span class="ft12 text-justify">Durante el plazo de vigencia de esto Contrato el "Arrendatario"
              se obliga a mantener a el "Arrendador" libre de toda
              responsabilidad sea cual fuere su naturaleza. Asimismo, el
              "Arrendatario" acepta de manera expresa pagar íntegramente todos
              los gastos, incluyendo los legales, así como los derivados de
              reclamaciones, ya sea judiciales o extrajudiciales o de cualquier
              tipo, por daños que se causen a pudieran causarse a terceras
              personas o a sus propiedades, con motivo de la fabricación,
              ensamble, instalación, propiedad, tenencia, almacenamiento, uso y
              funcionamiento de los bienes objeto del presente Contrato.
              <br /><br />
            </span>
            <span class="ft12 text-justify">Las obligaciones que en esta cláusula asume el "Arrendatario",
              quedarán vigentes aún con posterioridad al plazo del presente
              Contrato o de su vencimiento anticipado, entendiéndose desde ahora
              que el "Arrendatario" acepta expresamente que es su intención
              obligarse a pagar íntegramente y por su exclusiva cuenta, todas
              las cantidades que sean reclamadas por terceros con motivo de
              daños en su persona o en sus bienes, manteniendo libre de toda
              responsabilidad a el "Arrendador" en todo momento.
              <br />
            </span>
            <span class="ft12 text-justify">En el caso de que se originaren quejas o reclamaciones en contra
              de el "Arrendador" por los conceptos previstos en esta cláusula,
              el "Arrendador" dará aviso inmediatamente a el "Arrendatario" para
              que ésta cumpla con dichas quejas o reclamaciones o para que torne
              las acciones convenientes en caso de que el "Arrendatario"
              considere tales quejas Improcedentes, si transcurridos 30
              (treinta) días naturales después del aviso dado por el
              “Arrendador", el "Arrendatario" no hubiere satisfecho dichas
              quejas, ni tomado acciones contra las mismas, el "Arrendador"
              podrá efectuar alguna erogación derivada de las situaciones que
              prevé esta cláusula y en tal caso el "Arrendatario" queda obligado
              a reintegrarle a el "Arrendador" las cantidades que haya pagado
              por este concepto a más tardar el día siguiente a aquél en que le
              sea solicitado por escrito el reintegro por el "Arrendador".

              <br />
            </span>
            <span class="ft12">
              Si el "Arrendatario" no cumple en los términos que aquí se
              estipulan, éste se obliga, además de reintegrar las cantidades
              referidas, a pagar a el "Arrendador" un importe que se establece
              en la cláusula XXII de este Contrato, a partir de la fecha de
              incumplimiento y basta que se haga dicho reintegro a el
              "Arrendador".<br />
            </span>
            <span class="ft12Black text-justify"><br />XIII. CONFLICTOS.

              <br />
            </span>
            <span class="ft12 text-justify">En el caso de existir algún conflicto obrero patronal de
              naturaleza individual o colectiva entre el "Arrendatario" y sus
              trabajadores, queda entendido que los bienes arrendados objeto del
              presente Contrato por ser propiedad de el "Arrendador", no
              podrá(n) ser embargado(s), ni ser objeto de invasión o garantía
              por parte de los- trabajadores, por concepto de las prestaciones
              que les adeude el "Arrendatario".<br />
            </span>
            <span class="ft12Black text-justify"><br />XIV. GASTOS DEL CONTRATO. <br />
            </span>
            <span class="ft12 text-justify">El "Arrendatario" se obliga en este acto a pagar a el
              "Arrendador", todos los gastos derivados do la elaboración,
              ratificación y/o en su caso inscripción, en el Registro Público de
              la Propiedad y de Comercio que cause el presente Contrato.<br />
            </span>
          </div>
        </div>
        <footer class="footer">
          <div class="col-12">
            <span class="ft12Black text-center">
              8
            </span>
          </div>
        </footer>
      </div>
      <div id="page9-div" class="container interline border page-container p-3">
        <div class="col-12 text-justify content-wrap">
          <div class="col-12">
            <div class="text-justify">
              <span class="ft12Black">
                <br />XV. CAUSAS DE RESCISIÓN.<br />
              </span>
              <span class="ft12">
                El "Arrendador" queda facultado para rescindir el presente
                Contrato de Arrendamiento, en adición a otras causas que se
                mencionan dentro del propio Contrato, en los siguientes casos de
                incumplimiento por parte del "Arrendatario":<br />
              </span>
            </div>
            <div class="ml-3 col-12">
              <span class="ft12 text-justify">
                a. Por falta de pago puntual de uno o más de los pagos que por
                cualquier concepto de renta se estipulan en el presente
                Contrato.<br />
              </span>
              <span class="ft12 text-justify">
                b. Por incumplir el "Arrendatario" con cualquiera de las
                obligaciones a su cargo, que, en relación al cuidado de
                operación, se especifican en la cláusula IV de este Contrato.<br />
              </span>
              <span class="ft12">
                c. Por no dar aviso inmediato el "Arrendatario" a el
                "Arrendador", de cualquier situación que pudiera afectar física
                o jurídicamente a los bienes arrendados
                <br />
              </span>
              <span class="ft12 text-justify">d. Si el "Arrendatario" se abstiene de permitir a el
                "Arrendador" la inspección de los bienes. e. Si por actos u
                omisiones de el "Arrendatario", los bienes son objeto de embargo
                total o parcial ya sea éste, de orden civil, fiscal, laboral o
                de otro tipo.

                <br />
              </span>
              <span class="ft12 text-justify">e. Si por actos u omisiones de el "Arrendatario", los bienes
                son objeto de embargo total o parcial ya sea éste, de orden
                civil, fiscal, laboral o de otro tipo.

                <br />
              </span>
              <span class="ft12 text-justify">f. Si el "Arrendatario" es declarado en quiebra o suspensión de
                pagos.
                <br />
              </span>
              <span class="ft12 text-justify">g. Por afectar o gravar en cualquier forma los bienes
                arrendados.

                <br />
              </span>
              <span class="ft12">
                h. Por subarrendar en todo o en parte, o conceder a terceras
                personas el uso de los bienes arrendados, ceder o negociar en
                cualquier forma los derechos derivados de este Contrato.<br />
              </span>
              <span class="ft12 text-justify">i. Si el "Arrendatario" celebrase convenio para compensar a
                acreedores.

                <br />
              </span>
              <span class="ft12 text-justify">j. Por no cumplir el "Arrendatario" con cualquier otra
                obligación impuesta en este Contrato.<br />
              </span>
              <span class="ft12 text-justify">k. Si el "Arrendatario” modifica, retira o intenta retirar el
                dispositivo de localización del automotor materia de este
                contrato, mismo que autorizó se instalara por parte del
                "Arrendador". <br />
              </span>
            </div>
            <span class="ft12 text-justify">Cualquiera que sea la causa de rescisión de las señaladas en esta
              cláusula que el "Arrendador" aduzca para rescindir el presento
              Contrato de Arrendamiento, el "Arrendatario" asume la obligación
              de pagar a el "Arrendador" los daños y perjuicios derivados de la
              rescisión del presente Contrato.<br />
            </span>
            <span class="ft12 text-justify">Sin perjuicio de lo anterior, si el "Arrendatario" incumpliera
              cualquiera de las obligaciones asumidas en este Contrato o en los
              PAGARÉS correspondientes en su caso, el "Arrendador" estará
              autorizada a rescindir de pleno derecho el presente Contento, sin
              necesidad de declaración judicial, o bien a exigir su
              cumplimiento.<br />
            </span>
            <span class="ft12Black text-justify"><br />XVI. DEVOLUCIÓN, AUTORIZACIÓN DE RETIRO DEL VEHÍCULO Y/O
              INMOBIILIZACIÓN.<br />
            </span>
            <span class="ft12 text-justify">Concluida la vigencia del Contrato, el "Arrendatario" se obliga a
              entregar la unidad arrendada a el "Arrendador" de acuerdo con los
              términos establecidos en la Cláusula II inciso "c" de este
              contrato. Paralelamente a la devolución de la unidad arrendada, el
              "Arrendatario" entregará a el "Arrendador", la documentación de
              este, relativa a, comprobantes de pago de servicios, de impuestos
              y en general, a todo documento que corresponda a la unidad
              arrendada o tenga relación con ella.<br />
            </span>
            <span class="ft12 text-justify">Las Partes acuerdan que, concluida la vigencia del Contrato, o
              bien, por incumplimiento de las obligaciones a cargo del
              “Arrendatario” estipuladas en el Contrato, sin necesidad de
              declaratoria judicial alguna, y tampoco siendo necesario realizar
              ningún tipo de notificación o requerimiento, el "Arrendador” podrá
              por si, o por conducto de tercero instruido o autorizado para
              ello, proceder a retirar la unidad arrendada del lugar en el que
              se encuentre, ya sea en movimiento, o mediante grúa, o equipo
              necesario a efecto de que en forma inmediata se le restituya en su
              posesión material, Lo anterior no implica de ninguna forma
              renuncia a derechos fundamentales de las Partes, pues ambas
              consienten el procedimiento de recuperación de la unidad arrendada
              y que primordialmente el mismo obedece a que no se agraven las
              obligaciones a cargo del Arrendatario, ni se ponga en riesgo la
              unidad arrendada.<br />
            </span>
            <span class="ft12 text-justify">Así mismo, las Partes acuerdan que en caso de que ocurra
              cualquier evento de incumplimiento y en cualquier tiempo ulterior,
              el "Arrendador" podrá, a su discreción, inmovilizar la unidad de
              manera remota hasta que el incumplimiento sea resuelto
              satisfactoriamente pare el "Arrendador" y/o dar por vencido
              anticipadamente el presente contrato de arrendamiento sin
              responsabilidad alguna para el "Arrendador" y sin necesidad de
              intervención judicial, y por ende, el "Arrendador" podrá exigir el
              pago de la totalidad de las rentas, es decir la totalidad de los
              pagos mensuales vencidos y por vencerse y cualesquiera otras
              cantidades insolutas derivadas del presente arrendamiento,
              quedando en tal caso el “Arrendatario”, sin el beneficio de
              división del pago de la renta. En este supuesto, el “Arrendatario”
              se obliga a devolver la unidad arrendada al "Arrendador", en los
              términos del primer párrafo de la presente cláusula.<br />
            </span>
            <span class="ft12 text-justify">Ninguno de los derechos a que hace referencia esta cláusula
              deberán entenderse como exclusivos, pero cada uno debe de ser
              acumulativo y adicional a cualquier otro derecho antes mencionado
              o que se disponga en la ley. Ninguna renuncia, expresa o tácita,
              de el "Arrendador" de cualquier incumplimiento deberá considerarse
              como una renuncia de cualquier otro incumplimiento por parte de
              “Arrendatario” o una renuncia de cualquiera de los -derechos del
              "Arrendador".<br />
            </span>
            <span class="ft12 text-justify">En caso de ser necesario el "Arrendador" podrá seguir el
              procedimiento que contempla el Código Civil del Estado de Jalisco
              en su artículo 2124, o cualquier correlativo de la República
              Mexicana; al que ambas partes se adhieren literalmente. Para un
              mayor entendimiento se transcribe el artículo mencionado.<br />
            </span>
            <span class="ft12it text-justify"><br />"Artículo 2124,- Cuando así se convenga expresamente, si el
              arrendatario no entrega el vehículo en el lugar y tiempo pactados,
              el arrendador podrá pedir a las autoridades competentes o
              encargadas de la seguridad pública o de la vialidad, con la sola
              exhibición del contrato de arrendamiento o su copia certificada,
              que dicha autoridad dé orden a sus integrantes para que, a la
              vista del vehículo, lo recojan y pongan a disposición del
              arrendador.<br />
              <span class="ft12it">
                Dicha dependencia deberá poner el vehículo a disposición
                del arrendador, en un depósito de vehículos del municipio donde
                se arrendó el mismo o de la institución titular de la asistencia
                pública en el Estado."<br />
              </span>
            </span>
          </div>
        </div>
        <footer class="footer">
          <div class="col-12">
            <span class="ft12Black text-center">
              9
            </span>
          </div>
        </footer>
      </div>
      <div id="page10-div" class="container interline border page-container p-3">
        <div class="col-12 text-justify content-wrap">
          <div class="col-12">
            <div class="text-justify">
              <span class="ft12">
                Las partes acuerdan que en caso de que la devolución de la
                unidad arrendada se reclame judicialmente, el juez que conozca
                la causa podrá, a petición de el "Arrendador", decretar la
                detención de la unidad arrendada.<br />
              </span>
            </div>
            <span class="ft12 text-justify">
              El costo por la devolución y traslado de la unidad arrendada para
              su entrega a el "Arrendador" será por cuenta del “Arrendatario”,
              en su defecto por el “Aval” incluidos los trabajos de reparación o
              mantenimiento que requiera para su buen funcionamiento.<br />
            </span>
            <span class="ft12 text-justify">
              Pura efectos de lo aquí estipulado, bastará con que el
              "Arrendador" exhiba a la autoridad actuante ya sea jurisdiccional,
              administrativa (policía y/o vialidad y transporte) o cualquier
              autoridad, copia certificada del Contrato, así como un estado de
              cuenta de donde se desprenda el incumplimiento del
              “Arrendatario”.<br />
            </span>

            <span class="ft12Black"><br />
              XVII. OBLIGACIONES ADICIONALES DE ARRENDATARIO.
              <br />
            </span>
            <span class="ft12 text-justify">Adicionalmente a cualquier obligación a cargo del “Arrendatario”
              en términos del presente Contrato y durante la vigencia de este,
              el “Arrendatario” se obliga y será responsable de:

              <br /><br />
              <div class="ml-3 col-12">
                <span class="ft12 text-justify">a. Cumplir con todas las leyes, reglamentos y decretos de
                  cualquier dependencia u organismo gubernamental ya sea
                  ;federal, estatal o municipal, relacionadas con el uso,
                  posesión u operación de la unidad arrendada, y en taI virtud
                  obtener ;y mantener por su cuenta las licencias, permisos,
                  registros y demás documentación que se requiera de conformidad
                  con ;dichas leyes, reglamentos y decretos que sean aplicables
                  a la unidad arrendada, así como a su uso, posesión y/u
                  operación, debiendo consecuentemente, el "Arrendatario"
                  obtener y mantener vigente, la Licencia que le faculte el ;;
                  manejo de la unidad arrendada materia del contrato, durante la
                  vigencia del mismo. Será a cargo del “Arrendatario”
                  cualquier;infracción, multa o sanción impuesta por las
                  autoridades competentes ya sea federales, estatales o
                  municipales, en relación con lo anterior.
                  <br />
                </span>
                <span class="ft12 text-justify">b. Realizar a su costo todas las acciones tendientes o
                  necesarias para recuperar la unidad arrendada o defender el
                  uso y goce de la misma, en caso de despojo, perturbación o de
                  cualquier acto de terceros que afecte el uso o goce de la
                  unidad arrendada, así como notificar por escrito y de
                  inmediato a el "Arrendador" de dicha circunstancia. De darse
                  cualquiera de dichos supuestos, el "Arrendador" legitimará a
                  el “Arrendatario” para que ejercite las acciones o defensas,
                  cuando ello fuere necesario, sin perjuicio del derecho que
                  tiene el "Arrendador” de ejercitarlas directamente.

                  <br />
                </span>
                <span class="ft12">
                  c. Rembolsar a el "Arrendador"; en cuanto éste se lo solicite,
                  cualquier cantidad que el "Arrendador" hubiere erogado por
                  cuenta del “Arrendatario”, por obligaciones de pago a cargo de
                  este último derivada del Contrato.<br />
                </span>
                <span class="ft12 text-justify">d. El “Arrendatario” deberá manejar racionalmente los
                  recursos naturales y preservar el medio ambiente, acatando las
                  medidas y acciones dictadas por las autoridades competentes en
                  todo lo relacionado al uso de la unidad arrendada.

                  <br />
                </span>
                <span class="ft12 text-justify">e. Fijar en un sitio visible de la unidad arrendada y en
                  forma permanente, una etiqueta que indique que la unidad
                  arrendada es propiedad del “Arrendador”.<br />
                </span>
                <span class="ft12 text-justify">f. A Celebrar un Contrato de Prestación de Servicios,
                  teniendo como fin que el prestador de servicios le presente a
                  la “Arrendataria”, entre otros, los siguientes:<span class="ft12it text-justify">
                    i) Asesoría y gestión en la compra y/o venta de vehículos
                    automotrices nuevos y/o usados, para uso privado y/o
                    público, así como todo tipo de maquinaria; ii) Asesoría y
                    gestión en la compra y/o venta, distribución, importación y
                    exportación de toda clase de partes automotrices, tal como
                    refacciones, accesorios, materiales, pinturas, herramientas
                    y repuestos; iii) Asesoría y gestión para la prestación de
                    servicios de reparación, detallado, acondicionamiento y
                    mantenimiento de toda clase de vehículos automotrices; y iv)
                    La prestación de servicios de administración, servicios de
                    contabilidad, auditorías, diseños de controles internos,
                    manuales de operación, asesoría y capacitación. </span><br /><br />
                </span>
              </div>
            </span>

            <div v-if="data.tipoAendorsement || data.tipoAbound">
              <span class="ft12Black text-justify">
                XVIII. DEUDOR SOLIDARIO y AVAL.<br />
              </span>
              <span class="ft12 text-justify">El Señor
                <span v-bind:class="{ 'marca-aval': data.showMarca }" v-if="data.tipoAendorsement" class="ft11">
                  {{ data.nombre_aval }}
                </span>
                <span v-if="data.tipoAbout" class="ft11">
                  y
                </span>
                <span v-bind:class="{ 'marca-obligado': data.showMarca }" v-if="data.tipoAbound" class="ft11">
                  {{ data.nombre_obligado }},
                </span>
                se constituye(n) como Aval y Obligado solidario de el "Arrendatario", frente y a
                favor de el "Arrendador”, y en consecuencia hace suyas todas las
                obligaciones y prestaciones derivadas del presente Contrato a
                cargo del primero, comprometiéndose a cumplir en su totalidad al
                segundo, respondiendo absoluta e incondicionalmente del pago
                total y puntual, de las obligaciones de pago de el
                "Arrendatario" que le deriven o le puedan derivar conforme al
                presente Contrato y sus Anexos, renunciando a cualquier
                beneficio de orden, excusión y de división en su caso. Para
                estos efectos, se considera que les obligaciones derivadas de
                este Contrato y sus Anexos, son indivisibles. El "Aval" se
                obliga a cumplir con todos y cada uno de los términos aquí
                contenidos y en los Anexos, así corno a suscribir el Pagaré en
                su carácter de avalista, y responderá como obligado principal
                por el total del pago frente al "Arrendador", pactándose
                expresamente que las obligaciones que en éste acto contrae con
                el objeto de garantizar el cumplimiento del presente acuerdo de
                voluntades, no cesarán al término del plazo estipulado en éste,
                sino hasta que se haya dado cumplimiento integral al mismo, todo
                ello conforme a lo previsto por los Artículos 1347, 1466, 1467,
                1492, 1493, 1494, 1500, 1512 y 1514 del Código Civil para el
                Estado de Jalisco y sus correlativos en el Código Civil para el
                Distrito Federal.<br /><br />
              </span>
            </div>
            <span class="ft12Black text-justify">XIX. INTERESES MORATORIOS.<br />
            </span>
            <span class="ft12 text-justify">En el caso de falta de pago oportuno por parte de él
              "Arrendatario" de cualquiera de los pagos que por concepto de
              renta se hubiesen pactado en el presente Contrato, deberá pagar a
              el "Arrendador” intereses moratorios sobre los pagos por concepto
              de renta vencidos y no pagados a razón de una tasa mensual del 4%
              (cuatro por ciento), sin perjuicio de la facultad que tiene el
              "Arrendador" para rescindir este Contrato, como consecuencia del
              incumplimiento señalado.<br /><br />
            </span>
            <span class="ft12">
              Lo dispuesto en los párrafos anteriores, también será
              aplicable a aquellos casos en que el "Arrendador" efectúe
              cualquier pago que sea a cargo de él "Arrendatario", según se
              establece en este Contrato y esta última no lo reintegre a la
              primera, cuando se lo solicite.<br />
            </span>
          </div>
        </div>
        <footer class="footer">
          <div class="col-12">
            <span class="ft12Black text-center">
              10
            </span>
          </div>
        </footer>
      </div>
      <div id="page11-div" class="container interline border page-container p-3">
        <div class="col-12 text-justify content-wrap">
          <div class="col-12">
            <div class="text-justify">
              <span class="ft11Black">
                <br />
                XX. GASTOS DE COBRANZA.<br />
              </span>
            </div>
            <span class="ft11 text-justify">En caso de falta de pago puntual de alguna de las rentas
              señaladas en el presente contrato el "Arrendatario" se obliga a
              pagar una cuota fija diaria de $ 500.00 (Quinientos pesos 00/100
              M.N.) como penalización por gastos de cobranza, esto
              independientemente de lo correspondiente al importe de los
              intereses moratorios. Así mismo, el "Arrendatario" se obliga a
              pagar a el "Arrendador" los honorarios, costas y gastos que se
              generen por la recuperación del adeudo a su cargo, ya sea vía
              extrajudicial o judicial.<br />
            </span>
            <span class="ft11Black text-justify">
              <br />
              XXI. DEPOSITARIO. <br />
            </span>
            <span class="ft11 text-justify">Durante la vigencia del presente Contrato y hasta en tanto no se
              devuelva el equipo arrendado a el "Arrendador" por parte de él
              "Arrendatario", las partes convienen en que el bien arrendado
              permanecerá en posesión de el "Arrendatario", o de su
              Representante legal en caso de persona moral, a quién se designará
              como "Depositario", y comparece a la firma del presente Contrato,
              aceptando el cargo que se le confiere y la responsabilidad civil y
              penal que se le deriva, obligándose a su fiel desempeño en los
              términos de las disposiciones legales aplicables.<br /><br />
            </span>
            <span class="ft11Black"><br />
              XVII. OBLIGACIONES ADICIONALES DE ARRENDATARIO.
              <br />
            </span>
            <span class="ft11 text-justify">Durante la vigencia del presente Contrato y hasta en tanto no se
              devuelva el equipo arrendado a el "Arrendador" por parte de él
              "Arrendatario", las partes convienen en que el bien arrendado
              permanecerá en posesión de el "Arrendatario", o de su
              Representante legal en caso de persona moral, a quién se designará
              como "Depositario", y comparece a la firma del presente Contrato,
              aceptando el cargo que se le confiere y la responsabilidad civil y
              penal que se le deriva, obligándose a su fiel desempeño en los
              términos de las disposiciones legales aplicables. <br /><br />
            </span>
            <span class="ft11Black text-justify">XXII. TÍTULOS DE LAS CLAUSULAS.
              <br />
            </span>
            <span class="ft11 text-justify">Los títulos de las Cláusulas que aparecen en el presente acuerdo
              de voluntades se han puesto con el exclusivo propósito de
              facilitar su lectura, por tanto, no necesariamente definen ni
              limitan el contenido de las mismas. Para efectos de interpretación
              de cada cláusula deberá atenderse exclusivamente a su contenido y
              de ninguna manera a su título.

              <br />
            </span>
            <span class="ft11">
              Ambas partes declaran que en el presente Contrato no existe error,
              dolo, mala fe, o cualquier vicio que les haya impedido manifestar
              libremente su consentimiento.<br /><br />
            </span>
            <span class="ft11Black text-justify">
              XXIII. PERSONALIDAD.

              <br />
            </span>
            <span class="ft11 text-justify">En este mismo acto las partes se reconocen recíprocamente la
              personalidad con que comparecen a la firma del presente Contrato y
              renuncian expresamente en caso de cualquier controversia, a
              invocar la falta de personalidad propia o del otro, esto de
              conformidad con lo dispuesto por el artículo 37, párrafo segundo
              del Código de Procedimientos Civiles para el Estado de Jalisco y
              sus correlativos del Código Federal de Procedimientos Civiles, el
              del Distrito Federal y los de las demás entidades federativas.<br /><br />
            </span>
            <span class="ft11Black text-justify">XXIV. DOMICILIOS CONVENCIONALES.<br />
            </span>

            <span class="ft11 text-justify">Todos los avisos y notificaciones que las partes deban darse en
              relación con el presente Contrato, ya sea para efectos judiciales
              o extrajudiciales, se harán por escrito y se enviarán con acuse de
              recibo, mensajería, correo electrónico, o por cualquier otro medio
              que asegure que el destinatario reciba dichas notificaciones, Para
              los efectos anteriores, las partes señalan como sus domicilios los
              contenidos en las Declaraciones del presente Contrato.<br /><br />
            </span>
            <span class="ft11 text-justify">En caso de que cualquier cambio a los domicilios convencionales
              señalados no sea notificado a la otra parte dentro de los
              siguientes 5 (cinco) días naturales a que se realice el mismo, el
              aviso será considerado como válidamente dado si se hace a los
              domicilios señalados dentro del presente Contrato.<br />
            </span>
            <span class="ft11Black text-justify"><br />
              XXV. CLAUSULA ESPECIAL.
              <br />
            </span>
            <span class="ft11 text-justify">Este Contrato acompañado de la certificación del estado de cuenta
              por el Contador del "Arrendador”, será título ejecutivo, sin
              necesidad de reconocimiento de firma, ni de otro requisito previo
              o posterior<br />
            </span>
            <span class="ft11 text-justify">El estado de cuenta contendrá los datos sobre la identificación
              del presente Contrato, el importe de las rentas determinadas; las
              rentas vencidas no pagadas; las rentas pendientes por vencer; la
              variabilidad de la renta aplicable a las rentas determinables a
              cada período de pago; los intereses moratorios generados; la tasa
              de interés aplicable a intereses moratorios; y el importe de
              accesorios generados. <br /><br />
            </span>
            <div v-if="data.tipoABasic || data.tipoAbound">
              <span class="ft11Black text-justify">XXVI. AVISO DE PRIVACIDAD.
                <br />
              </span>
              <span class="ft11 text-justify">Los datos recabados por el “Arrendador”, (con domicilio
                señalado en la Declaración I.c.), con motivo del presente
                Contrato, el destino y su tratamiento, de conformidad con la Ley
                Federal de Datos Personales en Posesión de Particulares, y en
                cumplimiento en lo ordenado por el artículo 15 y 16 de la Ley
                citada, el “Arrendatario” y el “Aval” (si hay Depositario
                también se debe señalar) manifiestan que ya lo consultaron y es
                de su conocimiento, así mismo estos últimos otorgan su
                consentimiento tácito y explícito al contenido de la política de
                privacidad del “Arrendador”. <br /><br />
              </span>
            </div>
          </div>
        </div>
        <footer class="footer">
          <div class="col-12">
            <span class="ft12Black text-center">
              11
            </span>
          </div>
        </footer>
      </div>
      <div id="page12-div" class="container interline border page-container p-3">
        <div class="col-12 text-justify content-wrap">
          <div>
            <div class="text-justify">
              <span class="ft12Black"> <br />XXVII. JURISDICCIÓN.<br /> </span>
            </div>
            <span class="ft12 text-justify">
              Las partes convienen, asimismo, que el "Arrendador" podrá a su
              elección ejercer las acciones derivadas del presente Contrato,
              mediante los procedimientos establecidos en el Código de
              Procedimientos Civiles para el Estado de Jalisco, y su correlativo
              para Código de Procedimientos Civiles de la Ciudad de México, o
              bien mediante la acción cambiarla derivada del pagaré al que se
              hace referencia en este Contrato. <br />
            </span>
            <span class="ft12 text-justify">
              Una vez leído el presente Contrato por las partes y enterados de
              su alcance y efectos, el mismo es rubricado en dos tantos, del
              cual se entrega un ejemplar a cada parte, con el mismo valor
              probatorio, en la Ciudad de
            </span>
            <span class="ft12Black" v-bind:class="{ 'marca': data.showMarca }">
              {{ data.municipio_cliente }}, {{ data.estado_cliente }} con fecha del {{ data.fecha_contrato }}.
            </span>
            <br />
            <span class="ft12 text-justify">
              <br />Para estos efectos, se considera que les obligaciones
              derivadas de este Contrato y sus Anexos, son indivisibles. El
              "Aval" se obliga a cumplir con todos y cada uno de los términos
              aquí contenidos y en los Anexos, así corno a suscribir el Pagaré
              en su carácter de avalista, y responderá como obligado principal
              por el total del pago frente al "Arrendador", pactándose
              expresamente que las obligaciones que en éste acto contrae con el
              objeto de garantizar el cumplimiento del presente acuerdo de
              voluntades, no cesarán al término del plazo estipulado en éste,
              sino hasta que se haya dado cumplimiento integral al mismo, todo
              ello conforme a lo previsto por los Artículos 1347, 1466, 1467,
              1492, 1493, 1494, 1500, 1512 y 1514 del Código Civil para el
              Estado de Jalisco y sus correlativos en el Código Civil para el
              Distrito Federal.<br /><br />
            </span>
            <div class="col-12 mt-5"></div>
            <div class="col-12 row auto mt-5" v-if="data.tipoABasic || data.tipoAbound">
              <div class="col-3 text-center pt-4 auto"></div>
              <div class="col-6 text-center border-top border-dark auto pt-2 auto">
                <span class="ft11">
                  <span class="ft11Black">
                    GPI AUTO COMERCIAL SAPI DE C.V.
                  </span>
                  <br />
                  Representada en este acto por
                  <span class="ft11Black">Jesús Fernández Morán</span>
                  EL "ARRENDADOR"<br /><br /><br /><br />
                </span>
              </div>
              <div class="col-3 text-center pt-2 auto"></div>
            </div>
            <div class="col-12 row auto mt-5" v-if="data.tipoABasic || data.tipoAbound">
              <div class="col-3 text-center pt-4 auto"></div>
              <div class="col-6 text-center border-top border-dark auto pt-2 auto">
                <span class="ft11">
                  <span v-bind:class="{ marca: data.showMarca }" class="ft13Black">
                    {{ data.nombre_cliente }}<br />
                  </span>
                  <span v-if="data.tipoAmoral" class="ft11Black text-center">
                    Representado por
                  </span>
                  <span v-if="data.tipoAmoral" class="ft11 text-center">
                    <br> {{ data.reprecentante_legal }}<br />
                  </span>
                  "ARRENDATARIO"<br /><br /><br /><br />
                </span>
              </div>
              <div class="col-3 text-center pt-2 auto"></div>
            </div>
            <div class="col-12 row auto mt-5" v-if="data.tipoAbound">
              <div class="col-3 text-center pt-4 auto"></div>
              <div class="col-6 text-center border-top border-dark auto pt-2 auto">
                <span class="ft11">
                  <span v-bind:class="{ 'marca-obligado': data.showMarca }" class="ft13Black">
                    {{ data.nombre_obligado }}<br />
                  </span>
                  EL AVAL Y DEUDOR SOLIDARIO<br /><br /><br /><br />
                </span>
              </div>
              <div class="col-3 text-center pt-2 auto"></div>
            </div>
            <div class="col-12 row auto mt-5" v-if="data.tipoAendorsement">
              <div class="col-3 text-center pt-4 auto"></div>
              <div class="col-6 text-center border-top border-dark auto pt-2 auto">
                <span class="ft11">
                  <span v-bind:class="{ 'marca-aval': data.showMarca }" class="ft13Black">
                    {{ data.nombre_aval }}<br />
                  </span>
                  EL AVAL Y DEUDOR SOLIDARIO<br /><br /><br /><br />
                </span>
              </div>
              <div class="col-3 text-center pt-2 auto"></div>
            </div>
            <div class="col-12 row auto mt-5" v-if="data.tipoABasic || data.tipoAbound">
              <div class="col-3 text-center pt-4 auto"></div>
              <div class="col-6 text-center border-top border-dark auto pt-2 auto">
                <span class="ft11">
                  <span v-bind:class="{ marca: data.showMarca }" class="ft11">
                    {{ data.nombre_cliente }}<br />
                  </span>
                  EL "DEPOSITARIO"
                </span>
              </div>
              <div class="col-3 text-center pt-2 auto"></div>
            </div>
          </div>
        </div>
        <footer class="footer">
          <div class="col-12">
            <span class="ft12Black text-center">
              12
            </span>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";

export default {
  name: "ContatoPrenda",
  data() {
    return {};
  },
  validations() {
    return {};
  },
  props: {
    data: {
      type: Object
    }
  },
  methods: {
    preloader() {
      $(".preloader").fadeIn();
      $(".preloader")
        .delay(10)
        .fadeIn("slow");
    },
    preloaderHiden() {
      $(".preloader").fadeOut();
      $(".preloader")
        .delay(10)
        .fadeOut("slow");
    }
  },
  props: {
    data: {
      type: Object
    }
  },
  components: {},
  created() {
    window.scrollTo(0, 0);
  }
};
</script>
<style type="text/scss">
@import "./style.scss";
</style>



// WEBPACK FOOTER //
// src/views/contratoArrendamiento/contratoconprendaArrendamiento.vue